import { render, staticRenderFns } from "./reviewReportList.vue?vue&type=template&id=3f8be9e1&scoped=true"
import script from "./reviewReportList.vue?vue&type=script&lang=js"
export * from "./reviewReportList.vue?vue&type=script&lang=js"
import style0 from "./reviewReportList.vue?vue&type=style&index=0&id=3f8be9e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8be9e1",
  null
  
)

export default component.exports